import React from 'react';
import Typography from '@mui/material/Typography';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import Session from '../shared/Session';
import { DateTimeWidget } from '../core/DateTimeWidget';
import { copyTextToClipboard } from '../shared/Utilities';
import SJChart from '../core/Chart';


export default class Home extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            notes: [],
            reportResult: undefined,
            reportResultIndex: 0,
            taskResult: undefined,
            taskResultIndex: 0
        };
    }

    nextTaskResult() {
        if (Session.currentUser.isAdmin) {
            Session.api("GET", "/tasks/latest" + this.state.taskResultIndex, {}, (taskResult: any) => {
                this.setState({
                    taskResult: taskResult,
                    taskResultIndex: this.state.taskResultIndex + 1
                });
            });
        }
    }

    nextReportResult() {
        if (Session.currentUser.isAdmin) {
            Session.api("GET", "/reports/latest" + this.state.reportResultIndex, {}, (reportResult: any) => {
                this.setState({
                    reportResult: reportResult,
                    reportResultIndex: this.state.reportResultIndex + 1
                });
            });
        }
    }

    componentDidMount() {
        if (Session.currentUser) {
            Session.api("GET", "/notes/", {}, (notes: any) => {
                this.setState({
                    notes: notes
                });
            });
        } else {
            if (Session.token === "") {
                Session.loginDialog.setOpen();
            }
            Session.forcePageUpdateHook = this;
        }
    }

    render() {
        let noteElements = [];

        noteElements.push(
            <>
                <TextField
                    id="note"
                    key="new-note-button-label"
                    name='note'
                    label="New Note"
                    type="text"
                    multiline
                    maxRows={5}
                    variant="standard"
                    size="medium"
                    autoFocus={true}
                    style={{ margin: "0px" }}
                />
                <IconButton key={"new-note-button"} aria-label="add" onClick={() => {
                    Session.api("POST", "/notes/", {
                        value: (document.getElementById("note") as HTMLInputElement).value
                    }, (result: any) => {
                        this.setState({
                            notes: this.state.notes.concat(result)
                        });
                    });
                }}>
                    <AddIcon key={"new-note-icon"} />
                </IconButton>
            </>
        );

        for (let i = 0; i < this.state.notes.length; i++) {
            noteElements.push(
                <>
                    <Typography key={"note-buttons-" + i} variant="body1" align="left" gutterBottom component="p">
                        {this.state.notes[i].value}&nbsp;&nbsp;
                        <IconButton key={"copy-button-" + i} aria-label="copy" style={{ width: "32px", height: "32px" }} onClick={() => {
                            copyTextToClipboard(this.state.notes[i].value);
                        }}>
                            <ContentCopyIcon key={"copy-icon-" + i} />
                        </IconButton>
                        <IconButton key={"delete-button-" + i} aria-label="delete" style={{ width: "32px", height: "32px" }} onClick={() => {
                            Session.api("DELETE", "/notes/" + this.state.notes[i].id, {}, () => {
                                this.setState({
                                    notes: this.state.notes.filter((note: any) => note.id !== this.state.notes[i].id)
                                });
                            });
                        }}>
                            <RemoveIcon key={"remove-icon-" + i} />
                        </IconButton>
                    </Typography>
                </>
            );
        }

        return (
            <>
                {Session.currentUser === undefined ? <>
                    <Typography variant="h2" align="left" gutterBottom component="h2">
                        Hello, world!
                    </Typography>
                    <br />
                    <Typography variant="body1" align="left" gutterBottom>
                        This is an administrative area for managing cloud applications.
                    </Typography>
                    {/* <Typography variant="body1" align="left" gutterBottom>
                        Are you looking for a new WordPress site, custom application, or software engineering service?
                    </Typography> */}
                    <Typography variant="body1" align="left" gutterBottom>
                        {/* <a href="https://calendly.com/simplejay/consultation" target="_blank">Request a consultation</a>&nbsp;or&nbsp;<a href="mailto:info@simplejay.com" target="_blank">email us</a>.&nbsp;♥ */}
                        <a href="mailto:info@simplejay.com" target="_blank">Email us</a>&nbsp;♥
                    </Typography>
                    <br />
                    <br />
                    <a href="https://simplejay.com" target="_blank">
                        <img src="https://simplejay.com/wp-content/uploads/2024/05/logo320x77.png" />
                    </a>
                </> : noteElements}
                <br />
                <br />
                {Session.currentUser && Session.currentUser.isAdmin &&
                    <SJChart slug="ethereum_transactions" title="Ethereum Transactions Per Day" />
                }
                {Session.currentUser && Session.currentUser.isAdmin &&
                    <SJChart slug="vm_utilization" title="VM Utilization" />
                }
                <br />
                {this.state.reportResult !== undefined && <>
                    <br />
                    <br />
                    <Divider sx={{ borderBottomWidth: 2 }} />
                    <br />
                    <Typography variant='h6' align='left' gutterBottom component='h6'>
                        Latest Report Result: {this.state.reportResult.report.name} - {this.state.reportResult.report.template} ({this.state.reportResult.id})
                    </Typography>
                    <DateTimeWidget dt={this.state.reportResult.dt_created} addTimeAgo={true} />
                    <Button variant="contained" color="primary" style={{ margin: "0.3%" }} onClick={() => {
                        this.nextReportResult();
                    }}>Next Report Result</Button>
                    <div style={{ textAlign: "center", height: "75%" }}>
                        <iframe title="Latest Report" src={Session.apiBaseurl + "/report_results/" + this.state.reportResult.id +
                            "/" + this.state.reportResult.viewing_key} width={"100%"} style={{ maxWidth: "8.5in", height: "100%" }} />
                    </div>
                </>}
                {this.state.taskResult !== undefined && <>
                    <br />
                    <Divider sx={{ borderBottomWidth: 2 }} />
                    <br />
                    <br />
                    <Typography variant='h6' align='left' gutterBottom component='h6'>
                        Task Log: {this.state.taskResult.name} - {this.state.taskResult.function} ({this.state.taskResult.id}){this.state.taskResult.successful ? <CheckCircleIcon sx={{ color: "green" }} /> : <CancelIcon sx={{ color: "red" }} />}
                    </Typography>
                    <DateTimeWidget dt={this.state.taskResult.dt_created} addTimeAgo={true} />
                    <Button variant="contained" color="primary" style={{ margin: "0.3%" }} onClick={() => {
                        this.nextTaskResult();
                    }}>Next Log</Button>
                    <pre>
                        {this.state.taskResult.log}
                    </pre>
                </>}
                <br />
            </>
        );
    }
}
